import React, { useState, useRef, useEffect } from 'react';
import './CopyDialog.css';

interface CopyDialogProps {
  title: string;
  value: string;
  onClose: () => void;
}

export const CopyDialog: React.FC<CopyDialogProps> = ({ title, value, onClose }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Select text on mount
    if (inputRef.current) {
      inputRef.current.select();
    }
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback - text is already selected
      if (inputRef.current) {
        inputRef.current.select();
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      }
    }
  };

  const handleOverlayClick = () => {
    onClose();
  };

  return (
    <div className="copy-dialog">
      <div className="copy-dialog__overlay" onClick={handleOverlayClick} />
      <div className="copy-dialog__modal">
        <button 
          className="copy-dialog__close" 
          onClick={onClose}
          type="button"
        >
          ×
        </button>
        <h2 className="copy-dialog__title">{title}</h2>
        <div className="copy-dialog__content">
          <input
            ref={inputRef}
            type="text"
            readOnly
            value={value}
            className="copy-dialog__input"
            onClick={(e) => (e.target as HTMLInputElement).select()}
          />
          <button 
            className={`copy-dialog__btn ${copied ? 'copy-dialog__btn--copied' : ''}`}
            onClick={handleCopy}
            type="button"
          >
            {copied ? '✓ Kopiert!' : 'Kopieren'}
          </button>
        </div>
      </div>
    </div>
  );
};
